<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="WeCar Technology"
  >
    <rect width="96" height="96" rx="24" fill="#16A34A" />
    <path
      d="M25 31L37 66L48 31L59 66L71 31"
      stroke="white"
      stroke-width="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29 33L38.5 62L48 33L57.5 62L67 33"
      stroke="#16A34A"
      stroke-width="4"
      stroke-linecap="round"
      stroke-dasharray="8 9"
    />
  </svg>
</template>
